import {NgIf, NgTemplateOutlet} from '@angular/common';
import {
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
} from '@angular/core';

@Component({
	standalone: true,
	selector: 'green-lazy-img',
	imports: [NgIf, NgTemplateOutlet],
	template: `
		<ng-template #placeholder>
			<div
				id="skeleton"
				class="flex h-full w-full items-center justify-center bg-slate-200/70 dark:bg-slate-700/30">
				<svg
					class="w-1/4 min-w-[52px] max-w-[112px] h-auto text-slate-400 dark:text-slate-500"
					viewBox="0 0 48 40"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
					aria-hidden="true">
					<rect x="3" y="3" width="42" height="34" rx="6" />
					<circle cx="15" cy="14" r="3.5" />
					<path d="M3 31 L13 21 L19 27 L30 16 L45 31" />
				</svg>
			</div>
		</ng-template>

		<ng-container *ngIf="isLoading">
			<ng-container *ngTemplateOutlet="placeholder" />
		</ng-container>

		<img
			*ngIf="src && !isError; else placeholder"
			class="w-full h-full object-contain"
			[src]="src"
			(load)="hidePlaceholder()"
			(error)="error()"
			[alt]="alt" />
	`,
})
export class LazyImgComponent {
	@Input() src: string;
	@Input() alt = '';
	@Input() isLoading = true;

	@Output() isLoaded = new EventEmitter<boolean>();

	@HostBinding('class') class =
		'inline-block w-full aspect-video overflow-hidden rounded-lg bg-black';

	isError = false;

	constructor() {}

	hidePlaceholder() {
		this.isLoading = false;
		this.isLoaded.emit(true);
	}

	error(): void {
		this.isError = true;
	}
}
